



































































import { Vue, Component, Prop, Watch } from "vue-property-decorator"
import { EnergySource } from "../models/energy-source"
import { Game } from "../models/game"
import { Howl } from "howler"
@Component
export default class BuyItem extends Vue {
  get canBuy() {
    return this.money >= this.price
  }

  get money() {
    const state: Game = this.$store.state
    return state.money
  }

  get roundActive() {
    return this.$store.state.roundActive
  }

  get showIndicator() {
    return this.indicator
  }

  get roundedPrice() {
    return Math.round(this.price * 100) / 100
  }

  get price() {
    return this.amount * this.item.price
  }

  get megawatts() {
    return this.amount * this.item.mwatts
  }

  get paused() {
    return this.$store.state.paused
  }

  get popup() {
    return this.$store.state.popup
  }
  @Prop() public item!: EnergySource
  public show = false
  public top: number | null = null
  public indicator: boolean = false
  public notifications: number = 0
  public noFunds: number = 0
  public noneLeft: number = 0

  private amount = 1

  @Watch("amount")
  protected test(val: number, oldVal: number) {
    if (val < 0) {
      val = 0
    } else if (val > this.item.units) {
      val = this.item.units
    }
    this.amount = val
  }

  @Watch("source.units")
  protected foo(val: number, oldVal: number) {
    if (val < this.amount) {
      this.amount = val
    }
  }

  protected purchase() {
    if (this.roundActive && !this.paused) {
      if (this.amount === 0 || this.amount > this.item.units) {
        // insuifficient amount, fail
        this.noneLeft++
        if (!this.$store.state.muted) {
          new Howl({
            src: ["/audio/Insufficient Funds.mp3"]
          }).play()
        }
      } else if (this.money < this.price) {
        // insufficient cash, fail
        this.noFunds++
        if (!this.$store.state.muted) {
          new Howl({
            src: ["/audio/Insufficient Funds.mp3"]
          }).play()
        }
      } else {
        // successfully purchase
        this.notifications++
        this.$store.dispatch("userPurchase", {
          item: this.item,
          amount: this.amount
        })
        if (!this.$store.state.muted) {
          new Howl({
            src: ["/audio/Building built.mp3"]
          }).play()
        }
      }
    } else {
      if (!this.$store.state.muted) {
        new Howl({
          src: ["/audio/Click - Invalid.mp3"]
        }).play()
      }
    }
  }

  protected remove() {
    this.$store.dispatch("popup", false)
  }
}
